import { render, staticRenderFns } from "./TheaterDocumentationContainer.vue?vue&type=template&id=659413e1&scoped=true"
import script from "./TheaterDocumentationContainer.vue?vue&type=script&lang=js"
export * from "./TheaterDocumentationContainer.vue?vue&type=script&lang=js"
import style0 from "./TheaterDocumentationContainer.vue?vue&type=style&index=0&id=659413e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659413e1",
  null
  
)

export default component.exports